import http, { apiErrorMessage, descargarExcelPorToken } from '../../http';

const vRutaGestionPaquetes = 'gestion-paquetes/';

export const getListForTable = (sucursal) =>{
    return (dispatch, getState) => {
        http.get(vRutaGestionPaquetes + 'resumen', { params: { sucursal } })
            .then(function (response){
                // Envelope v1: {data:{izq,der,totales}}
                dispatch({
                    type: "GESTION_PAQUETES_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'GESTION_PAQUETES_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const LimpiarData = () =>{
    return (dispatch, getState) => {
        dispatch({type: "GESTION_PAQUETES_LIMPIAR_DATA"});
    }
}

export const LimpiarNombreExcel = () =>{
    return (dispatch, getState) => {
        dispatch({type: "GESTION_PAQUETES_EXCEL_LIMPIAR"});
    }
}

export const getExcelGuias = (tipo,sucursal) => {
    return (dispatch, getState) => {
        http.post(vRutaGestionPaquetes + 'excel', { tipo, sucursal })
            .then(function (response){
                // Envelope v1: {data:{nombreexcel,fileToken}}; el token firma la descarga
                dispatch({
                    type: "GESTION_PAQUETES_EXCEL", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'GESTION_PAQUETES_EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

// Descarga autenticada del .xlsx de un solo uso generado por getExcelGuias.
export const descargarExcel = (excel) => {
    return (dispatch, getState) => {
        descargarExcelPorToken('gestion-paquetes', excel.fileToken, excel.nombreexcel)
            .catch(function (error) {
                dispatch({ type: 'GESTION_PAQUETES_EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}
